import { Button, usePopoverContext } from '@electricjs/arc';
import { useNavigate } from 'react-router-dom';

import i18n from '@/i18n';

type SecondaryActionProps = {
  isDropDownMenu: boolean;
  requestId?: string;
  loading: boolean;
};

export const SecondaryAction = ({
  isDropDownMenu,
  requestId,
  loading,
}: SecondaryActionProps) => {
  const navigate = useNavigate();
  const { toggle } = usePopoverContext();

  if (!requestId) {
    return null;
  }

  const handleViewMore = () => {
    if (isDropDownMenu) {
      toggle();
    }

    setTimeout(() => {
      navigate(`/tasks/${requestId}`);
    }, 300);
  };

  return (
    <Button
      id={`button-view-more`}
      alignSelf="center"
      variant="outline"
      showSkeleton={loading}
      onClick={handleViewMore}>
      {i18n.t('common:notificationItems.actions.viewMore')}
    </Button>
  );
};
